import { isEmailValid } from "rylak-common/src/utils";
import { getBrandPrivacyPolicyUrl, getBrandTermsAndConditionsUrl } from "~/cores/brandDataCore";

export function emailSyntaxValidator({ getLocaleText }) {
    return {
        validator: (v) => {
            return isEmailValid(v);
        },
        text: getLocaleText("login.email_invalid"),
    };
}

export function requiredInputValidator({ getLocaleText }) {
    return {
        validator: (v) => !!(v && v?.trim()),
        text: getLocaleText("login.required-field"),
    };
}

export function getEmailValidators({ getLocaleText }) {
    return [emailSyntaxValidator({ getLocaleText }), requiredInputValidator({ getLocaleText })];
}

export function getOrderIdValidators({ getLocaleText }) {
    return [requiredInputValidator({ getLocaleText })];
}

export function isLoginInputValid(appProps, { termsAndConditionsValue, email, orderId }) {
    if ((getBrandTermsAndConditionsUrl(appProps) || getBrandPrivacyPolicyUrl(appProps)) && !termsAndConditionsValue) {
        return false;
    }
    if (getEmailValidators(appProps).find((v) => !v.validator(email))) {
        return false;
    }
    if (getOrderIdValidators(appProps).find((v) => !v.validator(orderId))) {
        return false;
    }
    return true;
}
